export default [
  {
    path: "/clientes/:client?",
    name: "menu-clients",
    component: () => import("@/views/pages/clients/Clients.vue"),
    meta: {
      authRequired: true,
      pageTitle: "Clientes",
    },
  },
  {
    path: "/financeiro",
    name: "menu-financeiro",
    component: () => import("@/views/pages/financial/Financial.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/usuarios/:user?",
    name: "menu-users",
    component: () => import("@/views/pages/users/Users.vue"),
    meta: {
      authRequired: true,
      pageTitle: "Usuários",
    },
  },
  {
    path: "/ajustes",
    name: "forca-ajustes",
    component: () => import("@/views/pages/account-setting/AccountSetting.vue"),
    meta: {
      authRequired: true,
    },
  },

  // *===============================================---*
  // *--------- NOTIFICATIONS & IT'S FILTERS N LABELS -------------------------------*
  // *===============================================---*
  {
    path: "/notificacoes",
    name: "forca-notifications",
    component: () => import("@/views/pages/notification/Notification.vue"),
    meta: {
      authRequired: true,
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
    },
  },
  {
    path: "/notificacoes/:folder",
    name: "forca-notifications-folder",
    component: () => import("@/views/pages/notification/Notification.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "forca-notifications",
    },
    beforeEnter(to, _, next) {
      if (
        ["sent", "draft", "starred", "spam", "trash"].includes(to.params.folder)
      )
        next();
      else next({ name: "error-404" });
    },
  },
  {
    path: "/notificacoes/label/:label",
    name: "forca-notifications-label",
    component: () => import("@/views/pages/notification/Notification.vue"),
    meta: {
      contentRenderer: "sidebar-left",
      contentClass: "email-application",
      navActiveLink: "forca-notifications",
    },
    beforeEnter(to, _, next) {
      if (
        ["personal", "company", "important", "private"].includes(
          to.params.label
        )
      )
        next();
      else next({ name: "error-404" });
    },
  },

  {
    path: "/error-404",
    name: "error-404",
    component: () => import("@/views/error/Error404.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },
  {
    path: "/login",
    name: "auth-login",
    component: () => import("@/views/pages/authentication/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/register",
    name: "auth-register",
    component: () => import("@/views/pages/authentication/Register.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/forgot-password",
    name: "auth-forgot-password",
    component: () => import("@/views/pages/authentication/ForgotPassword.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
    },
  },
  {
    path: "/pages/miscellaneous/coming-soon",
    name: "misc-coming-soon",
    component: () => import("@/views/pages/miscellaneous/ComingSoon.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/pages/miscellaneous/not-authorized",
    name: "misc-not-authorized",
    component: () => import("@/views/pages/miscellaneous/NotAuthorized.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
    },
  },
  {
    path: "/pages/miscellaneous/under-maintenance",
    name: "misc-under-maintenance",
    component: () => import("@/views/pages/miscellaneous/UnderMaintenance.vue"),
    meta: {
      layout: "full",
    },
  },
  {
    path: "/pages/miscellaneous/error",
    name: "misc-error",
    component: () => import("@/views/pages/miscellaneous/Error.vue"),
    meta: {
      layout: "full",
    },
  },
];
